import { useState, useEffect } from 'react';

const navItems = [
  { en: 'ABOUT', zh: '關於益維', href: '/about' },
  { en: 'PRODUCTS', zh: '產品介紹', href: '/product' },
  { en: 'NEWS', zh: '最新消息', href: '/news' },
  { en: 'CONTACT', zh: '聯絡我們', href: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`w-full z-50 transition-all duration-300 ${
        scrolled ? 'fixed top-0 bg-white shadow-sm' : 'relative bg-white'
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 h-20">
        {/* Logo */}
        <a href="/index" className="flex items-center gap-3 cursor-pointer">
          <img
            src="/images/logo.png"
            alt="益維企業有限公司"
            className="h-14 w-auto object-contain"
          />

        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item, i) => (
            <a
              key={item.en}
              href={item.href}
              className="group flex flex-col items-center px-6 py-2 cursor-pointer hover:text-[#1a73b5] transition-colors"
            >
              <span className="text-xs text-gray-400 group-hover:text-[#1a73b5] tracking-widest uppercase">{item.en}</span>
              <span className="text-base font-medium text-gray-700 group-hover:text-[#1a73b5] whitespace-nowrap">{item.zh}</span>
              {i < navItems.length - 1 && (
                <span className="absolute right-0 top-1/2 -translate-y-1/2 text-gray-300 hidden" />
              )}
            </a>
          ))}
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden flex flex-col gap-1.5 p-2 cursor-pointer"
          onClick={() => setMobileOpen(v => !v)}
          aria-label="Toggle menu"
        >
          <span className={`block w-6 h-0.5 bg-gray-700 transition-all ${mobileOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <span className={`block w-6 h-0.5 bg-gray-700 transition-all ${mobileOpen ? 'opacity-0' : ''}`} />
          <span className={`block w-6 h-0.5 bg-gray-700 transition-all ${mobileOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-white border-t border-gray-100">
          {navItems.map(item => (
            <a
              key={item.en}
              href={item.href}
              className="flex flex-col px-6 py-4 border-b border-gray-50 hover:bg-gray-50 cursor-pointer"
            >
              <span className="text-xs text-gray-400 uppercase tracking-widest">{item.en}</span>
              <span className="text-base font-medium text-gray-700">{item.zh}</span>
            </a>
          ))}
        </div>
      )}
    </header>
  );
}
